import { SortingOrder } from '@/components'
import { getNextSorting } from '@/components/common/SortingIconButton/getNextSorting'
import { getColumnSorting } from '@/components/common/Table/utils'
import { isLeaf } from '@/components/common/Table/utils/isLeaf'
import {
    Table as TanstackTable,
    SortingState,
    Header,
} from '@tanstack/react-table'
import { Dispatch, SetStateAction, useCallback } from 'react'

export const useTableSorting = (
    table: TanstackTable<unknown>,
    setSorting: Dispatch<SetStateAction<SortingState>>
) => {
    const setColumnSorting = useCallback(
        (id: string, sorting: SortingOrder) => {
            setSorting(
                sorting !== undefined ? [{ id, desc: sorting === 'desc' }] : []
            )
        },
        [setSorting]
    )

    const getTableColumnSorting = useCallback(
        (header: Header<unknown, unknown>) =>
            getColumnSorting(table, header.id),
        [table]
    )

    const onTableColumnHeaderClick = useCallback(
        (header: Header<unknown, unknown>) => {
            const isLeafHeader = isLeaf(header)
            if (isLeafHeader) {
                const sorting = getColumnSorting(table, header.column.id)
                const nextSorting = getNextSorting(sorting)
                setColumnSorting(header.column.id, nextSorting)
            }
        },
        [setColumnSorting, table]
    )

    return { onTableColumnHeaderClick, getTableColumnSorting }
}
